import Image, { StaticImageData } from 'next/image';
import { ErrorIcons } from '@nx-frontend/shared/types/error';

interface ErrorIconProps extends Omit<StaticImageData, 'src'> {
  name: ErrorIcons;
}

export function ErrorIcon({ name, ...props }: ErrorIconProps) {
  let icon: StaticImageData | string | null = null;

  switch (name) {
    case ErrorIcons.ERROR:
      icon = '/assets/img/error.png';
      break;
    case ErrorIcons.LOCKED:
      icon = '/assets/img/lock.svg';
      break;
    case ErrorIcons.NOT_FOUND:
      icon = '/assets/img/404.png';
      break;
    case ErrorIcons.REQUESTED:
      icon = '/assets/img/requested.png';
      break;
    case ErrorIcons.BLOCKED:
      icon = '/assets/img/blocked.png';
      break;
    case ErrorIcons.ENVELOPE:
      icon = '/assets/img/envelope.svg';
      break;
    case ErrorIcons.LOGIN:
      icon = '/assets/img/enter-door.svg';
      break;
  }

  return icon ? <Image src={icon} alt={name} {...props} /> : null;
}
